import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex-center flex-col p-4"
};
const _hoisted_2 = {
  class: "flex-center flex-col"
};
import Icon from "@/modules/vue/components/Icon.vue";
import EntityLink from "@/modules/vue/components/EntityLink.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'MissedGoalIncident',
  props: {
    liveIncident: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Icon, {
        icon: _ctx.IconEnum.Futbol,
        size: "4rem",
        class: "mb-4 opacity-20"
      }, null, 8, ["icon"]), _createElementVNode("div", _hoisted_2, [_createVNode(EntityLink, {
        entity: __props.liveIncident.incident.team,
        disabled: "",
        class: "mb-2"
      }, null, 8, ["entity"]), _createVNode(EntityLink, {
        entity: __props.liveIncident.incident.player,
        disabled: ""
      }, null, 8, ["entity"])])]);
    };
  }
});